/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_DescriptionInputs */



/**
* | output |
* | --- |
* | "Controls what autonomous agent runs may do on their own, for the whole organization." |
*
* @param {Agent_Policy_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_description = /** @type {((inputs?: Agent_Policy_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Legt für die gesamte Organisation fest, was autonome Agentenläufe eigenständig tun dürfen.")
	return /** @type {LocalizedString} */ ("Controls what autonomous agent runs may do on their own, for the whole organization.")
});